export const PARTNER_STORE_WITHOUT_POSTS = 1683;
